import { FC } from "react";

interface CreateIconSVGProps {
    className?: string;
}

const CreateIconSVG: FC<CreateIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.667 15.9993H21.3337M16.0003 10.666V21.3327M29.3337 15.9993C29.3337 23.3631 23.3641 29.3327 16.0003 29.3327C8.63653 29.3327 2.66699 23.3631 2.66699 15.9993C2.66699 8.63555 8.63653 2.66602 16.0003 2.66602C23.3641 2.66602 29.3337 8.63555 29.3337 15.9993Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CreateIconSVG;
